/*********************************************************
 BOOTSTRAP
**********************************************************/
import Util from "bootstrap/js/dist/util";
// import Alert from 'bootstrap/js/dist/alert'
import Button from "bootstrap/js/dist/button";
// import Carousel from 'bootstrap/js/dist/carousel';
import Collapse from "bootstrap/js/dist/collapse";
import Dropdown from "bootstrap/js/src/dropdown";
// import Modal from 'bootstrap/js/src/modal';
import Popover from "bootstrap/js/src/popover";
// import ScrollSpy from 'bootstrap/js/src/scrollspy';
import Tab from "bootstrap/js/src/tab";
// import Toast from 'bootstrap/js/src/toast';
import Tooltip from "bootstrap/js/src/tooltip";

/*********************************************************
 ADDITIONAL LIBS
**********************************************************/
import SmoothScroll from "smooth-scroll";
import "waypoints/lib/jquery.waypoints.min";

var jQueryBridget = require("jquery-bridget");
var Masonry = require("masonry-layout");

import lax from "lax.js";

/*********************************************************
 COYOTE SCRIPTS
**********************************************************/

jQueryBridget("masonry", Masonry, $);

jQuery(document).ready(function ($) {
  "use strict";

  // Smooth scroll for navigation links
  // var navScroll = new SmoothScroll('.nav-link, .toc-item a, .jumplink', {
  // 	speed: 1500,
  // 	speedAsDuration: true,
  // 	offset: 90,
  // 	easing: 'easeInOutQuint',
  // });

  // $('.nav-link, .toc-item a, .jumplink').click(function(e) {
  //   e.preventDefault();
  //   let target = $(this).attr('href');
  //   $([document.documentElement, document.body]).animate({
  //     scrollTop: $(target),
  //   }, 1500);
  // });

  // Offcanvas nav pip as progress
  var navpips = $(".report-section").waypoint({
    handler: function (direction) {
      if (direction === "down") {
        // Find the associated pip and fill it
        $(
          '#offcanvas-nav-el [data-section="' + this.element.id + '"]'
        ).addClass("mark-read");
      } else {
        $(
          '#offcanvas-nav-el [data-section="' + this.element.id + '"]'
        ).removeClass("mark-read");
      }
    },
    offset: "50%",
    // context: '#report-container'
  });

  // Toggle desktop nav on hover
  $("#offcanvas-nav-contain .offcanvas-nav").on("mouseenter", function () {
    $(this).closest("#offcanvas-nav-contain").addClass("opened");
  });
  $("#offcanvas-nav-contain .offcanvas-nav-wrap").on("mouseleave", function () {
    $(this).closest("#offcanvas-nav-contain").removeClass("opened");
  });

  const offcanvasHoverSlideDuration = 500;
  $("#offcanvas-nav-contain .nav-link-contain").hover(
    function () {
      // $(this).find('.section-info-collapse').slideDown();
      $(this)
        .find(".section-info-collapse")
        .stop(true, true)
        .slideDown(offcanvasHoverSlideDuration, function () {
          $(this).addClass("shown");
        });
    },
    function () {
      // $(this).find('.section-info-collapse').slideUp();
      $(this)
        .find(".section-info-collapse")
        .stop(true, true)
        .removeClass("shown")
        .delay(100)
        .slideUp(offcanvasHoverSlideDuration);
    }
  );

  // Shy nav header
  if (!$("body").hasClass("page-template-page-surveydata")) {
    var previousScroll = 0;
    $(window).scroll(function () {
      var currentScroll = $(this).scrollTop();
      var introDistance =
        window.pageYOffset +
        $("#report-intro")[0].getBoundingClientRect().top +
        600;
      if (
        currentScroll > introDistance &&
        currentScroll < $(document).height() - $(window).height()
      ) {
        if (currentScroll > previousScroll) {
          $("#site-inner-header > .navbar")
            .removeClass("is-visible")
            .addClass("is-hidden");
          if (
            $("#site-inner-header > .navbar .navbar-collapse").hasClass("show")
          ) {
            $("#site-inner-header .navbar-toggler").click();
          }
        } else {
          $("#site-inner-header > .navbar")
            .removeClass("is-hidden")
            .addClass("is-visible")
            .addClass("scrolling");
        }
        previousScroll = currentScroll;
      }
    });
  }

  // Remove .first-load once mobile nav has been opened once
  $(".navbar-toggler").click(function () {
    $(this).removeClass("first-load");
  });

  // Force hide mobile nav after click element
  $("#report-primary-navigation .nav-item a").click(function () {
    setTimeout(function () {
      $("#report-primary-navigation").collapse("hide");
    }, 500);
  });

  // Glossary/Key Masonry
  $(".aucoyote-module.definition_list .masonry-wrap").masonry({
    // columnWidth: '.grid-sizer',
    itemSelector: ".list-term-contain",
    gutter: 90,
    // percentPosition: true,
  });

  // Map Sidebar Toggle
  $(".key-toggle-flag").on("click", function () {
    $(this).closest(".arc-wrapper").toggleClass("key-opened");
  });

  // Simple parallax solution

  window.onload = function () {
    lax.init();

    // Add a driver that we use to control our animations
    lax.addDriver("scrollY", function () {
      return window.scrollY;
    });

    // Add animation bindings to elements
    lax.addElements(".lax-image", {
      scrollY: {
        translateY: [
          ["elInY", "elCenterY", "elOutY"],
          ["elHeight/2", "0", "-elHeight/2"],
        ],
      },
    });
    lax.addElements(".lax-bars", {
      scrollY: {
        translateY: [
          ["elInY", "elCenterY", "elOutY"],
          ["elHeight/3", "0", "-elHeight/3"],
        ],
      },
    });
    lax.addElements(".lax-plotline", {
      scrollY: {
        translateY: [
          ["elInY", "elCenterY", "elOutY"],
          ["elHeight/5", "0", "-elHeight/5"],
        ],
      },
    });
    lax.addElements(".lax-grid", {
      scrollY: {
        translateY: [
          ["elInY", "elCenterY", "elOutY"],
          ["elHeight/6", "0", "-elHeight/6"],
        ],
      },
    });
    lax.addElements(".lax-section-image", {
      scrollY: {
        translateY: [
          ["elInY", "elCenterY", "elOutY"],
          ["elHeight/4", "0", "-elHeight/4"],
        ],
      },
    });
    lax.addElements(".parallax-layer.header-image", {
      scrollY: {
        translateY: [
          ["elInY", "elCenterY", "elOutY"],
          ["elHeight/5", "0", "-elHeight/5"],
        ],
      },
    });
  };

  var halfViewportHeight = viewport.height / 2;
  var quarterViewPortHeight = (viewport.height * 3) / 4;

  changeCssOnScroll(
    $(".report-title.anim-text"),
    "letter-spacing",
    "em",
    0.1,
    0.2,
    -halfViewportHeight,
    halfViewportHeight
  );
  changeCssOnScroll(
    $(".report-title.anim-text"),
    "width",
    "%",
    100,
    120,
    -halfViewportHeight,
    halfViewportHeight
  );
  changeCssOnScroll(
    $(".report-title.anim-text"),
    "width",
    "%",
    100,
    120,
    -halfViewportHeight,
    halfViewportHeight
  );
  changeCssOnScroll(
    $(".report-title.anim-text"),
    "left",
    "%",
    0,
    -10,
    -halfViewportHeight,
    halfViewportHeight
  );
  changeCssOnScroll(
    $(".report-subtitle.anim-text"),
    "letter-spacing",
    "em",
    0.08,
    0.2,
    -quarterViewPortHeight,
    halfViewportHeight
  );
  changeCssOnScroll(
    $(".report-subtitle.anim-text"),
    "width",
    "%",
    100,
    120,
    -quarterViewPortHeight,
    halfViewportHeight
  );
  changeCssOnScroll(
    $(".report-subtitle.anim-text"),
    "left",
    "%",
    0,
    -10,
    -quarterViewPortHeight,
    halfViewportHeight
  );
  // changeCssOnScroll( $('.anim-text-border'), 'letter-spacing', 'em', 0.2, 0.3, -300, 300 );
  changeCssOnScroll(
    $(".report-section-header hr"),
    "width",
    "%",
    0,
    100,
    -viewport.height,
    halfViewportHeight,
    true
  );

  // Need to trigger a resize when tableaus inserted, because they screw up
  // the page height & thus the parallax offsets
  // const tableauObserver = new ResizeObserver(() => {
  //   $(window).trigger('resize');
  // })
  // tableauObserver.observe(document.querySelector('.tableauPlaceholder'));
}); // End $(document).ready();

/*
 * Use this handy function and variable to get the CSS viewport dimensions.
 * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
 */
function updateViewportDimensions() {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;
  return { width: x, height: y };
}

var viewport = updateViewportDimensions();

/*
 * Throttle Resize-triggered Events
 * Wrap your actions in this function to throttle the frequency of firing them off, for better performance, esp. on mobile.
 * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
 */
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout(timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

// how long to wait before deciding the resize has stopped, in ms. Around 50-100 should work ok.
var timeToWaitForLast = 100;

function changeCssOnScroll(
  el,
  property,
  units = "",
  start,
  end,
  offset,
  distance,
  debug = false
) {
  el.css("transition", "all 0.1s ease-in-out");
  el.each(function () {
    $(window).on(
      "scroll",
      {
        element: $(this),
        property: property,
        units: units,
        offset: offset,
        distance: distance,
        end: end,
        start: start,
      },
      updateCssValue
    );
  });
}

function updateCssValue(event) {
  let elTop = event.data.element.offset().top;
  let elTrigger = elTop + event.data.offset;
  let elFinish = elTrigger + event.data.distance;
  if (elTrigger - 200 < $(window).scrollTop() < elFinish + 200) {
    let progress = Math.max($(window).scrollTop() - elTrigger, 0);
    let progressPercent =
      progress / event.data.distance < 1 ? progress / event.data.distance : 1;
    let newValue =
      progressPercent * (event.data.end - event.data.start) + event.data.start;
    $(event.data.element).css(event.data.property, newValue + event.data.units);
  }
}

// Function to add 'drawn' class to animated line drawings
function addDrawnClass(el) {
  el.classList.add("drawn");
}
function addPlayClass(el) {
  el.classList.add("playvideo");
}

// Entry Animations (dep: 'scroll-reveal')
jQuery(document).ready(function ($) {
  $(window).on("load", function () {
    (function scrollReveal() {
      window.sr = new ScrollReveal({
        reset: false,
        distance: "100%",
        duration: 2500,
      });

      sr.reveal(".hero-content", { delay: 100, origin: "top" });
      sr.reveal(".header-content", { delay: 100, origin: "top" });
      sr.reveal(".hero-right", {
        delay: 700,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-1", {
        delay: 900,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-2", {
        delay: 1100,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-3", {
        delay: 1200,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-4", {
        delay: 1400,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-5", {
        delay: 1500,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-6", {
        delay: 1700,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-7", {
        delay: 1800,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
      sr.reveal(".hero-right .image-8", {
        delay: 2000,
        origin: "bottom",
        viewOffset: { bottom: -1000 },
      });
    })();

    let section_defaults = {
      reset: false,
      distance: "100%",
      duration: 2500,
      delay: 0,
      viewOffset: {
        bottom: -400,
      },
    };

    ScrollReveal().reveal(".cafb-green .image-right", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "right", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal(".cafb-lightergreen .image-right", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "right", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal(".cafb-darkgreen .image-right", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "right", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal(".cafb-lightgreen .image-right", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "right", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal(".cafb-darkgreen .image-left", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "left", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal(".cafb-lightergreen .image-left", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "left", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal(".cafb-green .image-left", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "left", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal(".cafb-lightgreen .image-left", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "left", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal("#report-header .report-title", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "bottom", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal("#report-header .report-title-year", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "top", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal().reveal("#report-header .image-left", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "left", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal(section_defaults).reveal("#report-header .image-right", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      reset: false,
      distance: "100%",
      duration: 1000,
      delay: 0,
      origin: "right", // Animation origin
      viewOffset: {
        bottom: 100,
      },
    });
    ScrollReveal(section_defaults).reveal("#report-header .image-left2", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      delay: 500,
      origin: "bottom",
    });
    ScrollReveal(section_defaults).reveal("#report-header .image-right2", {
      opacity: 0, // Start fully transparent
      easing: "ease-in", // Animation easing
      delay: 500,
      origin: "bottom",
    });

    ScrollReveal(section_defaults).reveal(".report-section-header .img-1", {
      delay: 0,
      origin: "left",
    });
    ScrollReveal(section_defaults).reveal(".report-section-header .img-2", {
      delay: 0,
      origin: "right",
    });
    ScrollReveal(section_defaults).reveal(".report-section-header .img-3", {
      delay: 500,
      origin: "right",
    });
    ScrollReveal(section_defaults).reveal(
      ".report-section-header .section-number",
      { delay: 250, origin: "left" }
    );
    ScrollReveal(section_defaults).reveal(
      ".report-section-header .section-heading",
      { delay: 500, origin: "left" }
    );

    // Add 'drawn' class to lines when enter viewport
    ScrollReveal().reveal(".draw-me", {
      distance: "0px",
      duration: 0,
      beforeReveal: addDrawnClass,
      viewOffset: { bottom: -400 },
    });
  });

  ScrollReveal().reveal("video", {
    distance: "0px",
    duration: 0,
    beforeReveal: addPlayClass,
    //afterReveal : removePlayClass,
    viewOffset: { bottom: 100 },
  });
  jQuery(window).scroll(function () {
    jQuery(".wp-video-shortcode").each(function () {
      var str = jQuery(this).attr("id");
      var arr = str.split("_");
      const video = document.getElementById(str);
      if (jQuery(this).hasClass("playvideo")) {
        video.play();
        video.addEventListener("timeupdate", function () {
          if (this.currentTime >= this.duration - 0.5) {
            this.pause();
            jQuery("#" + str).removeClass("playvideo");
          }
        });
      }
    });
  });

  jQuery(
    ".page-template-page-2023-report .aucoyote-module.split-column_content .column-type-pull-quote figure span.ldquo"
  ).html(
    '<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 40 30" fill="none"><path fill="#CB6E24" d="M18.733 2.59C9.477 4.317 4.848 9.712 4.518 17.482c1.102-2.266 3.526-3.345 6.391-3.345 4.298 0 7.383 2.697 7.383 7.554 0 4.532-3.085 8.309-9.036 8.309C3.746 30 0 26.223 0 18.993 0 10.576 5.29 1.727 17.961 0l.772 2.59ZM40 2.59c-9.256 1.727-13.884 7.122-14.215 14.892 1.102-2.266 3.526-3.345 6.391-3.345 4.298 0 7.383 2.697 7.383 7.554 0 4.532-3.085 8.309-9.036 8.309-5.51 0-9.256-3.777-9.256-11.007 0-8.417 5.29-17.266 17.962-18.993L40 2.59Z" opacity=".4"/></svg>'
  );
});

(function ($) {
  $(document).ready(function () {
    var $win = $(window);
    var elementTop, elementBottom, viewportTop, viewportBottom;

    function isScrolledIntoView(elem) {
      elementTop = $(elem).offset().top;
      elementBottom = elementTop + $(elem).outerHeight();
      viewportTop = $win.scrollTop();
      viewportBottom = viewportTop + $win.height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    if ($('img[src$="gif"]').length) {
      var gifSrc, srcGif;

      $('img[src$="gif"]').each(function () {
        gifSrc = $(this).attr("src");
        $(this).attr("data-gif", gifSrc);
      });

      $win.on("scroll.gifrun", function () {
        $('img[src$="gif"]').each(function () {
          srcGif = $(this).attr("data-gif");

          if (!(isScrolledIntoView(this) === true)) {
            $(this).attr("src", srcGif);
          } else {
            if ($(this).attr("src") == srcGif) {
              // do nothing
            } else {
              $(this).attr("src", srcGif);
            }
          }
        });
      }); /* end $win.on('scroll.gifrun') */
    } /* end img[src$="gif"] */
  });
})(jQuery);
